module.exports = __webpack_public_path__ + "img/ticon1.343fecbf.png";